/**
 * <s-countdown> — HH:MM:SS countdown.
 * data-end: optional ISO date/time shared by every visitor.
 * Without it, each visitor gets their own countdown of data-duration-hours,
 * started on their first visit and remembered in localStorage.
 * Hides its closest <aside> once the countdown reaches zero.
 */
const STORAGE_KEY = 'announcement-countdown-start';

class SCountdown extends HTMLElement {
  #timer;
  #end;

  connectedCallback() {
    this.#end = this.#resolveEnd();
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #resolveEnd() {
    const fixed = (this.dataset.end || '').trim();
    if (fixed) {
      const date = new Date(fixed);
      if (!Number.isNaN(date.getTime())) return date.getTime();
    }

    const hours = Number(this.dataset.durationHours) || 24;
    let start = NaN;
    try {
      start = Number(window.localStorage.getItem(STORAGE_KEY));
      if (!Number.isFinite(start) || start <= 0) {
        start = Date.now();
        window.localStorage.setItem(STORAGE_KEY, String(start));
      }
    } catch {
      // Storage blocked (private mode etc.): count from this page view.
      start = Date.now();
    }
    return start + hours * 3600 * 1000;
  }

  #tick() {
    let remaining = Math.max(0, Math.floor((this.#end - Date.now()) / 1000));
    if (remaining === 0) {
      clearInterval(this.#timer);
      const bar = this.closest('aside');
      if (bar) bar.hidden = true;
      return;
    }
    const h = Math.floor(remaining / 3600);
    remaining -= h * 3600;
    const m = Math.floor(remaining / 60);
    const s = remaining - m * 60;
    const pad = (n) => String(n).padStart(2, '0');
    const value = this.querySelector('[data-countdown-value]');
    if (value) value.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
